
import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import BookingHero from './components/BookingHero';
import BookingForm from './components/BookingForm';
import BookingInfo from './components/BookingInfo';
import { useSEO, generateBookingSchema, generateWebPageSchema, generateBreadcrumbSchema } from '../../utils/seo';

export default function BookingPage() {
  const [scrolled, setScrolled] = useState(false);
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Book a Free Painting Quote Watford | Brushour Hertfordshire',
    description: 'Book a free consultation with Brushour painters and decorators in Watford, Hertfordshire. Schedule your visit for a professional assessment and detailed quote for painting and decorating services.',
    keywords: 'book painter Watford, free painting quote Hertfordshire, schedule decorator consultation, painting appointment Watford, decorating consultation Hertfordshire',
    canonical: `${SITE_URL}/booking`,
    schema: [
      generateBookingSchema(),
      generateWebPageSchema('Book a Free Painting Quote – Brushour Watford', 'Schedule your free consultation and painting quote in Watford and Hertfordshire', `${SITE_URL}/booking`),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Book a Visit', url: `${SITE_URL}/booking` },
      ]),
    ],
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      <BookingHero />
      <BookingInfo />
      <BookingForm />
      <Footer />
    </div>
  );
}
